import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Loading from 'components/Loading';
import LoginService from 'services/Login/service';

const FormResendCode = ({ userEmail, isRegister }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [timer, setTimer] = useState(0);

    const resendCodeAuth = (event) => {
        event.preventDefault();
        setIsLoading(true);
        try{
            Promise.all([LoginService.authToken({
                'user': userEmail
            }, (isRegister?'register':'reset'))]).then(auth => {
                console.log("auth", auth);
            });
        }catch(error){
            console.error(error);
        }
        setTimeout(() => {
            startTimer(30);
        }, 1500);
    }
    const startTimer = (timeOut) => {
        setTimer(timeOut);
        setIsLoading(false);
        const intervalTimer = setInterval(() => {
            setTimer(timeOut--);
            if(timeOut < 0) clearInterval(intervalTimer);
        }, 1000);
    }

    return (
        <>{timer > 0 
            ?
            <p className="legend text-center red">Podrás solicitar un nuevo código en <strong>{timer}</strong> seg.</p>
            :
            <div className="legend text-center red">
                ¿No recibiste el código? 
                {!isLoading
                    ?
                    <a style={{ marginLeft: '5px' }} href="#" onClick={(e) => resendCodeAuth(e)}><strong>Reenviar código</strong></a>
                    :
                    <Loading type="metro size-mini"/>
                }
            </div>
        }</>
    );
}

FormResendCode.propTypes = {
    userEmail: PropTypes.string,
    isRegister: PropTypes.bool
};
export default FormResendCode;